const SortOrder = {
    relevance: '関連性スコア',
    asc: '商品名 あーん',
    desc: '商品名 んーあ',
    ratings: '評価順',
};

export { SortOrder };
